import { GenericService } from './generic.service';
import { CodeableConcept } from '@/lib';

export class CodeableConceptService extends GenericService<CodeableConcept> {

  constructor() {
    super('v1/codeable-concepts');
  }
}
